module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_13-6eec326082c5e123bdf2cd849b66fd0f.svg";